import { put, takeEvery } from 'redux-saga/effects';

import { OfficeAction } from '../actions';
import { OfficeConstant } from '../constants';

export default function* () {
  yield takeEvery(
    [OfficeConstant.CREATE_OFFICE_SUCCESS, OfficeConstant.EDIT_OFFICE_SUCCESS],
    createOrEditOfficeSuccess,
  );
  yield takeEvery(OfficeConstant.DELETE_OFFICE_SUCCESS, deleteOfficeSuccess);
  yield takeEvery(OfficeConstant.GET_OFFICES_SUCCESS, getOfficesSuccess);
  yield takeEvery(OfficeConstant.GET_OFFICE_SUCCESS, getOfficeSuccess);
  yield takeEvery(
    OfficeConstant.UPLOAD_OFFICE_LOGO_SUCCESS,
    uploadOfficeLogoSuccess,
  );
}

function* createOrEditOfficeSuccess() {
  yield put(OfficeAction.setOffice({ clear: true }));
}

function* deleteOfficeSuccess() {
  yield put(OfficeAction.getOffices());
}

function* getOfficesSuccess(action) {
  yield put(OfficeAction.setOffices({ ...action?.payload, clear: false }));
}

function* getOfficeSuccess(action) {
  yield put(OfficeAction.setOffice({ ...action?.payload, clear: false }));
}

function* uploadOfficeLogoSuccess(action) {
  yield put(
    OfficeAction.setOffice({
      ...action?.payload,
      clear: false,
      logo: action?.payload?.[0]?.path,
    }),
  );
}
